import type { ReactNode } from "react";

export interface PageContainerProps {
  children: ReactNode;
  /** Optional banner rendered full-width above the centred page content. */
  banner?: ReactNode;
}

export function PageContainer({ children, banner }: PageContainerProps) {
  return (
    <div className="min-h-full bg-[#f3f4f6]">
      {banner ? <div className="w-full px-8 pt-4">{banner}</div> : null}
      <div className="w-full px-8 py-4">{children}</div>
    </div>
  );
}
